const invertedPositions = {
    top: 'bottom',
    bottom: 'top',
};
const keysInvertedPositions = Object.keys(invertedPositions);
const findKeyInDirection = (direction) => keysInvertedPositions.find((key) => (direction === null || direction === void 0 ? void 0 : direction.search(key)) >= 0);
const hasKeyInDirection = (direction) => !!findKeyInDirection(direction);
const getInvertedPlacement = (placement) => {
    const direction = findKeyInDirection(placement);
    const invertedDirection = invertedPositions[direction];
    return placement.replace(direction, invertedDirection);
};
const getWindowMeasures = () => ({
    windowScrollTop: window.pageYOffset || document.documentElement.scrollTop,
    screenHeight: window.innerHeight,
});
const getInvertedTopOrBottomDirection = (measures, placement) => {
    const { screenHeight } = getWindowMeasures();
    let heightElement = 0;
    let scrollTopElement = 0;
    if (measures) {
        heightElement = measures.height;
        scrollTopElement = measures.y;
    }
    const emptyAreaBottom = screenHeight - scrollTopElement;
    let hasLimitedExceeded = emptyAreaBottom < heightElement;
    if (placement.search('top') >= 0) {
        const emptyAreaTop = scrollTopElement + heightElement;
        hasLimitedExceeded = emptyAreaTop < heightElement;
    }
    return hasLimitedExceeded ? getInvertedPlacement(placement) : null;
};
function debounce(func, delay) {
    let timeoutId = null;
    const debouncedFunc = (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
    debouncedFunc.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    return debouncedFunc;
}

export { debounce, getInvertedTopOrBottomDirection, hasKeyInDirection };
